import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { injectIntl, FormattedMessage } from "react-intl";
import IconHexagon from "@learningblocks/exp-constants/lib/Icons/hexagon-solid";
import { MathJax } from "better-react-mathjax";

// Check if content includes LaTeX
const containsMath = (text) => {
  if (!text) return false;
  return typeof text === "string" && /\$\$.*\$\$/.test(text);
};

const SummaryTextBase = ({ className, heading, items }) => {
  const renderList = (items, heading = false) => (
    <ul style={{ marginTop: heading ? 16 : 0 }}>
      {items.map((item, index) => {
        const icon_style =
          typeof item === "object" ? { top: "4px" } : { top: "1px" };
        const textContent = item?.text || "";

        return (
          <li key={index}>
            <div className="index" style={icon_style}>
              <IconHexagon style={{ fill: "#003E6B", height: "18px" }} />
            </div>
            <span>
              {containsMath(textContent) ? (
                <MathJax>
                  <RichText {...item} />
                </MathJax>
              ) : (
                <RichText {...item} />
              )}
            </span>
            {item.items ? renderList(item.items) : null}
          </li>
        );
      })}
    </ul>
  );

  return (
    <div className={className} dir="auto">
      <h5>
        {heading ? (
          <FormattedMessage
            id={heading}
            defaultMessage={heading}
            description=""
          />
        ) : null}
      </h5>
      {renderList(items, heading)}
    </div>
  );
};

SummaryTextBase.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  items: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

SummaryTextBase.defaultProps = {
  className: "summaryText",
};

export const SummaryText = injectIntl(SummaryTextBase);
